import React, { useState } from 'react';
import './Epc.scss';
import downArrow from '../../images/down.svg';

const EPCCertificate = ({ propertyData,title }) => {
  // Create a toggle state for each media item using index
  const [openIndexes, setOpenIndexes] = useState({});

  const toggleEPC = (index) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };


  return (
      propertyData.epcGraph && Array.isArray(propertyData.epcGraph) && (
        <section className="epc-section"> 
          {propertyData.epcGraph
            .filter((item) => item?.srcUrl && item?.show_pdf === false)
            .map((item, index) => (
              <div className="epc-container" key={index}>
                <div className="epc-header" onClick={() => toggleEPC(index)}>
                  <span className="epc-heading">{title || item.caption || 'EPC'}</span>
                  <img
                    src={downArrow}
                    alt="Toggle Icon"
                    className={`epc-icon ${openIndexes[index] ? 'rotated' : ''}`}
                  />
                </div>

                {openIndexes[index] && (
                  <div className="epc-images-wrapper">
                    <img
                      src={item.srcUrl}
                      alt={item.caption}
                      className="epc-image"
                    />
                  </div>
                )}
              </div>
            ))}
        </section>
      )
  );
};

export default EPCCertificate;
